import { useStation } from '@app/core/stations/hooks/useStation';

export function useAudiogramTemplates(stationId: string) {
  const station = useStation(stationId);

  return {
    templates: station.featuresConfig?.fragments?.audiogram?.templates || [],
    station,
  };
}
